// extracted by mini-css-extract-plugin
module.exports = {"layer":"Style_layer__p2bPy","layer-dark":"Style_layer-dark__OUDTI"};